import { render, staticRenderFns } from "./bdmsg.vue?vue&type=template&id=c4aa9300&scoped=true&"
import script from "./bdmsg.vue?vue&type=script&lang=js&"
export * from "./bdmsg.vue?vue&type=script&lang=js&"
import style0 from "./bdmsg.vue?vue&type=style&index=0&id=c4aa9300&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4aa9300",
  null
  
)

export default component.exports